import { useTranslation } from "react-i18next";

import { AuthCard, ForgotPasswordForm } from "@/components/auth";

export function ForgotPasswordPage() {
  const { t } = useTranslation("auth");

  return (
    <AuthCard title={t("forgotPassword.title")} description={t("forgotPassword.subtitle")}>
      <ForgotPasswordForm />
    </AuthCard>
  );
}

export default ForgotPasswordPage;
